enum CcsAccountType {
  V1 = 'V1',
  V2 = 'V2',
  INVALID = 'INVALID',
}

export default CcsAccountType;
